import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { Pagarme } from "../icon/pagarme";

const HeaderBox = styled(Box)`
  margin-top: 32px;

  div {
    padding: 0;
  }
`;

export function WhiteHeader() {
  return (
    <HeaderBox sx={{ flexGrow: 1 }}>
      <Toolbar>
        <Pagarme />
      </Toolbar>
    </HeaderBox>
  );
}
